angular.module('picmonicng').directive('searchBar', [
  'SearchService',
  '$timeout',
  'BrowseService',
  '$state',
  'SuggestionsResource',
  'UserService',
  function (SearchService, $timeout, BrowseService, $state, SuggestionsResource, UserService) {
    return {
      restrict: 'E',
      link: function (scope, element) {
        scope.SearchService = SearchService;
        scope.searchTerm = '';
        scope.selectedSuggestionIndex = null;
        scope.suggestions = [];
        scope.suggestionsVisible = false;

        element
          .find('input')
          .bind('keydown', function (e) {
            switch (e.keyCode) {
              case 38: // up arrow
                e.preventDefault();
                scope.$apply(function () {
                  scope.previousSuggestion();
                });
                break;
              case 40: // down arrow
                e.preventDefault();
                scope.$apply(function () {
                  scope.nextSuggestion();
                });
                break;
              case 13: // enter
                scope.$apply(function () {
                  scope.handleEnter();
                });
                break;
            }
          })
          .bind('click', function () {
            if (SearchService.searchTerm && !BrowseService.secondaryVisible && !scope.ltiSelect) {
              scope.$apply(function () {
                BrowseService.go('app.search', {}, { force: true });
              });
            }
          })
          .bind('blur', function ($event) {
            scope.$apply(function () {
              SearchService.focused = false;
              SearchService.showSuggestions =
                $event.relatedTarget && angular.element($event.relatedTarget).hasClass('suggestions-result');
            });
          })
          .bind('focus', function () {
            SearchService.focused = true;
            SearchService.showSuggestions = true;
          });

        scope.$watch(
          function () {
            return SearchService.searchTerm;
          },
          function (newVal, oldVal) {
            if (newVal !== oldVal) {
              scope.searchSuggestions(SearchService.searchTerm);
            }
          }
        );

        scope.handleEnter = function () {
          if (scope.selectedSuggestionIndex !== null) {
            scope.selectSuggestion(scope.selectedSuggestionIndex);
          } else {
            scope.suggestionsVisible = false;
            scope.search();
          }
        };

        scope.nextSuggestion = function () {
          if (!scope.suggestions.total || !scope.suggestions.$resolved) {
            return;
          }

          if (scope.selectedSuggestionIndex === null) {
            scope.selectedSuggestionIndex = 0;
          } else if (scope.selectedSuggestionIndex + 1 > scope.suggestions.total - 1) {
            scope.selectedSuggestionIndex = 0;
          } else {
            scope.selectedSuggestionIndex++;
          }
        };

        scope.previousSuggestion = function () {
          if (!scope.suggestions.total || !scope.suggestions.$resolved) {
            return;
          }

          if (scope.selectedSuggestionIndex === null) {
            scope.selectedSuggestionIndex = scope.suggestions.total - 1;
          } else if (scope.selectedSuggestionIndex - 1 < 0) {
            scope.selectedSuggestionIndex = scope.suggestions.total - 1;
          } else {
            scope.selectedSuggestionIndex--;
          }
        };

        scope.search = function () {
          if (!SearchService.searchTerm) {
            SearchService.searching = false;
            scope.suggestionsVisible = false;
            return;
          }

          SearchService.searching = true;

          if (scope.ltiSelect) {
            $state.go('lti_selection', null, { reload: true });
          } else {
            BrowseService.go('app.search', {}, { force: true });
          }
        };

        scope.searchSuggestions = function () {
          // If a user has chosen a suggestion from the list no need to run additional suggestions on the selected term
          if (scope.skipNextSuggestionSearch) {
            scope.skipNextSuggestionSearch = false;
            return;
          }

          // cancel any existing searches
          if (typeof scope.suggestions.$cancelRequest === 'function' && !scope.suggestions.$resolved) {
            scope.suggestions.$cancelRequest();
          }

          // reset which suggestion is selected
          scope.selectedSuggestionIndex = null;
          scope.suggestionsVisible = false;

          // run suggestions search
          scope.suggestions = SuggestionsResource.queryv3({
            query: SearchService.searchTerm,
            markets: UserService.user.user_packages,
          });

          // show suggestions after search is complete
          scope.suggestions.$promise.then(
            function () {
              scope.suggestionsVisible = true;
            },
            function () {
              // do nothing when cancelled early
            }
          );
        };

        scope.selectSuggestion = function (index) {
          if (!scope.suggestions.total || !scope.suggestions.$resolved) {
            return;
          }

          scope.skipNextSuggestionSearch = true;
          SearchService.searchTerm = scope.suggestions.data[index].term;
          scope.suggestionsVisible = false;

          scope.search();
        };

        scope.clearSearch = function () {
          SearchService.reset();

          if (BrowseService.secondaryVisible) {
            BrowseService.go('app.search', {}, { force: true });
          }
        };

        if (scope.ltiSelect) {
          element.find('input').focus();
        }
      },
    };
  },
]);
